// Client-side PDF export via print. Simple, reliable, no server dep.
import { formatMoney, formatPercent } from "@/lib/prefs";

export function printRecipe({ recipe, costed, ingredientsById, allergens }) {
  const win = window.open("", "_blank", "width=800,height=1000");
  if (!win) return;
  const ingredientRows = (recipe.ingredients || []).map((line, idx) => {
    const ing = ingredientsById[line.ingredient_id];
    const lineCost = costed?.lines?.[idx]?.cost;
    return `<tr>
      <td>${line.quantity} ${line.unit}</td>
      <td>${ing?.name || "-"}</td>
      <td class="right">${lineCost ? formatMoney(lineCost.total) : "-"}</td>
    </tr>`;
  }).join("");
  const methodItems = (recipe.method || []).map((s, i) => `<li><span class="num">${i + 1}</span>${s}</li>`).join("");
  const allergenBadges = (allergens || []).map((a) => `<span class="badge">${a}</span>`).join(" ");

  const html = `<!DOCTYPE html>
<html><head><title>${recipe.name}</title>
<style>
  body { font-family: 'Fraunces', Georgia, serif; color: #1c1917; padding: 48px; max-width: 720px; margin: 0 auto; }
  h1 { font-size: 42px; margin: 0 0 4px; letter-spacing: -0.02em; }
  .eyebrow { font-family: 'Inter', sans-serif; text-transform: uppercase; letter-spacing: 0.22em; font-size: 11px; color: #78716c; }
  img { width: 100%; height: 280px; object-fit: cover; margin: 24px 0; border-radius: 6px; }
  .row { display: flex; justify-content: space-between; gap: 24px; margin: 12px 0 24px; padding: 12px 0; border-top: 1px solid #e7e5e4; border-bottom: 1px solid #e7e5e4; font-family: 'Inter', sans-serif; font-size: 13px;}
  .row div span { display:block; font-size: 22px; font-family: 'Fraunces', serif; }
  h2 { font-size: 20px; margin: 32px 0 12px; letter-spacing: -0.01em; }
  table { width: 100%; border-collapse: collapse; font-family: 'Inter', sans-serif; font-size: 13px; }
  td { padding: 8px 0; border-bottom: 1px solid #f5f5f4; }
  .right { text-align: right; font-variant-numeric: tabular-nums; }
  ol { padding: 0; list-style: none; font-family: 'Inter', sans-serif; font-size: 13px; }
  ol li { margin: 10px 0; padding-left: 32px; position: relative; }
  ol li .num { position: absolute; left: 0; top: 0; width: 22px; height: 22px; border-radius: 50%; background: #fef3c7; color: #92400e; font-size: 11px; display:flex; align-items:center; justify-content:center; font-weight: 600;}
  .badge { display:inline-block; padding:3px 8px; border-radius:9999px; background:#fef3c7; color:#78350f; font-family:'Inter',sans-serif; font-size:10px; letter-spacing:0.1em; text-transform:uppercase; margin-right:4px;}
  @media print { body { padding: 24px; } }
</style></head><body>
  <div class="eyebrow">${recipe.bracket || "recipe"}</div>
  <h1>${recipe.name}</h1>
  ${recipe.description ? `<p style="color:#57534e;">${recipe.description}</p>` : ""}
  ${allergenBadges ? `<div style="margin: 12px 0;">${allergenBadges}</div>` : ""}
  ${recipe.image_url ? `<img src="${recipe.image_url}" alt="${recipe.name}" />` : ""}
  <div class="row">
    <div>Cost / serving<span>${formatMoney(costed.perServing)}</span></div>
    <div>Sell price<span>${formatMoney(costed.sellPrice)}</span></div>
    <div>Food cost<span>${costed.sellPrice > 0 ? formatPercent(costed.foodCostPercent, 1) : "-"}</span></div>
    <div>Servings<span>${recipe.servings}</span></div>
  </div>
  <h2>Ingredients</h2>
  <table>${ingredientRows}</table>
  <h2>Method</h2>
  <ol>${methodItems}</ol>
</body></html>`;
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => win.print(), 400);
}
